<template lang="pug">
  v-text-field(
    v-model="model"
    v-bind="$attrs"
    :rules="_rules")
</template>

<script>
import { computed, watch } from '@vue/composition-api'
import isIban from './is-iban/'

export default {
  props: {
    value: String,
    rules: Array
  },

  setup (props, { emit }) {
    const model = computed({
      get: () => props.value,
      set: value => {
        emit(`input`, value)
      }
    })

    watch(
      () => props.value,
      value => {
        model.value = props.value
      }, {
        immediate: true
      }
    )

    const _rules = computed(
      () => [
        ...props.rules,
        value => isIban(value) || `La valeur saisie n'est pas un IBAN valide.`
      ]
    )

    return {
      _rules,
      model
    }
  }
}
</script>
